<template>
  <a-modal title="选择物料" v-model="modalVisible" @ok="onConfirm" :confirmLoading="loading" destroyOnClose>
    <a-form-model ref="ruleFormRef" :model="materialForm" autoComplete="off" :wrapperCol="{ span: 19 }" :labelCol="{ span: 4 }">
      <a-form-model-item label="物料编码" :rules="[baseRequiredRule]" prop="itemCode">
        <global-select
          :value.sync="materialForm.itemCode"
          selectType="selectAssembleSearch"
          requestApi="/mdm/mdmItemSystemItem/selectItemCodeBox"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          searchParam="itemCode"
          :setParams="{ itemType: 'ZCBCP' }"
          :dropdown-match-select-width="false"
          sourseField="res"
          :totalNum="9999999999"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  apiRoutingLineCcItem
} from '@/api/mes/basedata/standardProcessNew'
export default {
  name: 'MaterialSelectModal',
  components: {},
  props: {
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    this.baseRequiredRule = { required: true, message: ' ' }
    return {
      modalVisible: false,
      loading: false,
      materialForm: {}
    }
  },
  methods: {
    show() {
      this.modalVisible = true;
      this.materialForm = {};
    },
    onClose() {
      this.modalVisible = false;
    },
    onConfirm() {
      this.$refs.ruleFormRef.validate(valid => {
        if(valid) {
          this.loading = true;
          const { id: routingId } = this.detailData;
          apiRoutingLineCcItem({ routingId, ...this.materialForm }).then(res => {
            if(res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('successCall');
              this.onClose();
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
</style>
